<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <div class="animated fadeIn fContainer" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('Pettycashes.title')}}</strong>
                <!--<span class="float-right">{{$t('Pettycashes.text')}}</span>-->
                <div class="float-right">

                  <router-link :to="{ path: '/pettycash'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('Pettycash.new')}}</router-link>
                </div>
              </div>
              <div class="card-body card-block fColumn fColumn">
                <div class="fContent">

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_from" class=" form-control-label">{{ $t('Pettycashes.dt_from') }}
                      <span class="validatorrequired">({{ $t('validator.required') }})</span></label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_from" name="data.dt_from" v-model="data2.dt_from" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                 :title="$t('Pettycash.dt_from')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_from')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="dt_to" class=" form-control-label">{{ $t('Pettycashes.dt_to') }}
                      <span class="validatorrequired">({{ $t('validator.required') }})</span></label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText type="DatetimepickerBp"
                                 id="dt_to" name="data.dt_to" v-model="data2.dt_to" v-validate="{date_format:'yyyy-MM-dd','isodate':true, required:true}" hasToKeyboard="auto" value=""
                                 :title="$t('Pettycash.dt_to')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.dt_to')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <!--<div class="row form-group">-->
                    <!--<div class="col col-md-3"><label class=" form-control-label">{{ $t('Pettycash.transfered') }}</label>-->
                    <!--</div>-->
                    <!--<div class="col-12 col-md-9">-->
                      <!--<select id="transfered" v-model="data2.transfered" class="form-control mandatory w100" name="transfered">-->
                        <!--<option value="">-</option>-->
                        <!--<option value="0">{{$t('global.no')}} </option>-->
                        <!--<option value="1">{{$t('global.yes')}} </option>-->
                      <!--</select>-->
                    <!--</div>-->
                  <!--</div>-->


                  <!--<div class="alert alert-warning">// Ez igazából nem kell.</div>-->


                  <TableDatatableJs :head="head" :data="data"/>

                </div>
              </div>
            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';

  import Api from '@/api/Api';
  import HelperRole from '@/helper/HelperRole';
  import AlertInPage from '@/components/AlertInPage.vue';
  import moment from 'moment';
  import InputText from '@/components/InputText.vue';

  export default {
    name: 'Pettycashes',
    data() {
      const modul = this;
      // "id","id_company","text"
      return {
//        moduleRights: []
//        , moduleRightsIds: []
//        , roles: []
//        , user_role: 0
//        ,
        Helper: Helper
        ,
        data2: {
          dt_from: moment.utc().local().add(-1, 'month').format('YYYY-MM-DD'),
          dt_to: moment.utc().local().format('YYYY-MM-DD'),
          transfered: ""
        },
        year: "",
        yearOptions: [],
        month: "",

        data: [],
        head: [
          {
            modulname: modul.name,
            title: "Pettycashes.dttitle",
            data: "id",
            link: true,
            linkurl: "pettycash",
            linkclass: "text-nowrap",
            linkiconclass: "menu-icon fa fa-edit btn-link",
            linktext: "", // Pettycashes.linktext
          }
          /*
           businesspartner
           identifier
           currency
           price_sum_gross
           pettycash_type
           dt_make
           */
          , {
            key: "businesspartner",
            title: "Pettycash.businesspartner",
            searchField: true,
            xlsfield: true,
            sortDirection: "asc",
          }
          , {
            key: "identifier",
            title: "Pettycash.identifier",
            searchField: true,
            xlsfield: true,
          }
          , {
            key: "currency",
            title: "Pettycash.currency",
            searchField: true,
            xlsfield: true,
          }
          , {
            key: "price_sum_gross",
            title: "Pettycash.price_sum_gross",
            searchField: true,
            xlsfield: true,
            classtd: "text-right text-nowrap",
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              let user_sumprice_huf_number_of_decimals = (Number(modul.user_sumprice_huf_number_of_decimals) !== "NaN") ? Number(modul.user_sumprice_huf_number_of_decimals) : 0;
              if (modul.state && modul.state.usersettings && modul.state.usersettings.user_sumprice_huf_number_of_decimals) {
                user_sumprice_huf_number_of_decimals = modul.state.usersettings.user_sumprice_huf_number_of_decimals
              }
              return Helper.getFormattedPriceSegmentation(dataRowheadRowkey,user_sumprice_huf_number_of_decimals);
            },

          }
          , {
            key: "pettycash_type",
//            i18Key: "global.yesno",

            i18Key: "Pettycash.pettycashtypevalues",
            title: "Pettycash.pettycash_type",
            searchField: true,
            xlsfield: true,
          }
          , {
            key: "dt_make",
            title: "Pettycash.dt_make",
            searchField: true,
            xlsfield: true,
          }
          , {
            key: "pettycash_create_dt",
            title: "Pettycash.pettycash_create_dt",
            render: function (dataRowheadRowkey, type, dataRow, meta) {
              return Helper.getDisplaUTCDateTime(dataRow.pettycash_create_dt);
            },
            searchField: true,
            xlsfield: true,
          }


        ]
        , breadcrumbstitle: 'Pettycashes.title'
        , breadcrumbsData: [
          {
            'title': "Pettycashes.title",
          },
        ]
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 5000,
        }

      };
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElements();
        }
      },

      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },
      'data2.dt_from': function (newVal, oldVal) {
        const modul = this;
        if (modul.timer) {
          clearTimeout(modul.timer);
        }
        modul.timer = setTimeout(function () {
          if (newVal && newVal !== oldVal) {
            modul.$validator.validateAll().then((result) => {
              if (result) {
                modul.getElements();
              }
            });
          }
        }, 1000);
      },
      'data2.dt_to': function (newVal, oldVal) {
        const modul = this;
        if (modul.timer) {
          clearTimeout(modul.timer);
        }
        modul.timer = setTimeout(function () {
          if (newVal && newVal !== oldVal) {
            modul.$validator.validateAll().then((result) => {
              if (result) {
                modul.getElements();
              }
            });
          }
        }, 1000);
      },
      'data2.transfered': function (newVal, oldVal) {
        const modul = this;
        if (modul.timer) {
          clearTimeout(modul.timer);
        }
        modul.timer = setTimeout(function () {
          if (newVal !== oldVal) {
            modul.$validator.validateAll().then((result) => {
              if (result) {
                modul.getElements();
              }
            });
          }
        }, 1000);
      },

    },
    mounted() {
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);
      modul.handleRights();
      const actualYears = [moment().get("year"), moment().get("year") - 1, moment().get("year") - 2];
      const actualMonth = moment().get("month") + 1;
//                const actualYears = [moment.utc().get("year"), moment.utc().get("year") - 1, moment.utc().get("year") - 2];
//                const actualMonth = moment.utc().get("month") + 1;
      const yearOptions = [];
      Array.prototype.forEach.call(actualYears, function (e) {
        yearOptions.push({'value': e, 'text': e});
      });
      const selectedYear = "" + actualYears[0];
      const selectedMonth = "" + actualMonth;
      modul.yearOptions = yearOptions;
//                modul.year = selectedYear;
//                modul.month = selectedMonth;

      const actualDt2 = moment();
//        actualDt2.subtract('months', 1);
//        actualDt2.set('date', 1);
//        actualDt2.set('hour', 0);
//        actualDt2.set('minute', 0);
//        actualDt2.set('second', 0);
//        actualDt2.set('millisecond', 0);
      modul.data2.dt_from = actualDt2.clone().subtract('months', 3).format('YYYY-MM-DD HH:mm:ss');
      modul.data2.dt_to = actualDt2.clone().format('YYYY-MM-DD HH:mm:ss'); // .endOf('month')
      modul.year = actualDt2.get("year");
      modul.month = actualDt2.get("month");


    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [18], [16, 20])) {
          modul.hasRole = true;
        }
        if (modul.$store.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        modul.getElements();

      },

//      modulRowIdCb: function (data, type, row, meta) {
//        const modul = this;
//        console.log("--" + data);
//        return "" + row.identifier_pre_id + row.identifier_counter;
//      },
//      renderType(data, type, row, meta){
//        const modul = this;
//        if (Number(row.id_businesspartner)>0) {
//          return modul.$t("global.contacttype.businesspartner")
//        }
//        if (Number(row.id_store)>0) {
//          return modul.$t("global.contacttype.store")
//        }
//        if (Number(row.id_address)>0) {
//          return modul.$t("global.contacttype.address")
//        }
//      },
//      renderEntity(data, type, row, meta){
//        const modul = this;
//        if (Number(row.id_businesspartner)>0) {
//          return row.businesspartnerbusinesspartnername;
//        }
//        if (Number(row.id_store)>0) {
//          return row.storetext;
//        }
//        if (Number(row.id_address)>0) {
//          return row.addressname;
//        }
//      },
//      chkRole(){
//        const modul = this;
//        modul.hasRole = false;
//        const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
//        if (!Helper.checkRoles(modul.roles, role)) {
//          modul.hasRole = false;
////        modul.$router.push({name: "dashboard"})
//        } else {
//          modul.hasRole = true;
//        }
//      },
      getElements(){
        const modul = this;
        const data = {
          dt_from: modul.data2.dt_from,
          dt_to: modul.data2.dt_to,
          transfered: modul.data2.transfered,
        };

        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getPettycashes({id_company: modul.$store.state.id_company, data: data}).then(function (res) {
          modul.AlertInPage.msg = "";
          if (res && res.result) {
            modul.data = Array.from(res.data);
          } else {
            modul.AlertInPage.msg = "form.error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          }

//          const res = result;
//          modul.data = Array.from(result);
          console.log(res);

        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      handlePayedHandler(event, data, type, row, meta){
        console.log(event, row);
        const modul = this;

        const fnCb = function () {
          const dt_transfer = moment().format('YYYY-MM-DD');
          const id = row.id;
          console.log(JSON.stringify(row));
          const postData = {
            dt_transfer: dt_transfer,
            transfered: "1"
          }
          modul.AlertInPage.msg = "form.in_progress";
          modul.AlertInPage.type = "warning";
          Api.savePettycashTransfered({id_company: modul.$store.state.id_company, id: id, data: postData}).then(function (res) {
            if (res && res.result) {
              if (Helper.Number(res.data.transfered) === 1) {
                modul.getElements();
              }
            }

//          const res = result;
//          modul.data = Array.from(result);
            console.log(res);
//          console.log(modul);
//          console.log("modul.state");
//          console.log(modul.state);
//          console.log("modul.state.appVersion");
//          console.log(modul.state.appVersion);
//            modul.AlertInPage.msg = "";

            modul.AlertInPage.msg = "form.save_succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(2000));

          }, function (e) {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));
          });


        }
        modul.$eventBus.$emit('modal', {
          type: "confirm",
          msgTitle: "",
          tmsgTitle: "question",
          msgText: modul.$t("InvoiceInbounds.settransfered_question"),
          tmsgText: "",
          fnCancel: function () {
            console.log('fnCancel')
          },
          fnConfirm: function () {
            console.log('fnConfirm')
            fnCb()
          }
        });


      },

      renderyesno: function (data, type, row, meta) { // data, type, row, meta
        const modul = this;
        let transfered = false;
        if (row.transfered && !isNaN(Number(row.transfered)) && Number(row.transfered) === 1) {
          transfered = true;
        }
        return (transfered) ? modul.$t("global.yes") : modul.$t("global.no");
      }
    },

    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      AlertInPage,
      InputText,
    },
  };
</script>








